import axios from 'axios';

// 在代码中添加调试语句
// console.log('当前 API 地址:', process.env.VUE_APP_API_URL)
const axiosInstance = axios.create({
  // Vue的axios配置
  baseURL : process.env.VUE_APP_API_URL,
  // baseURL : "https://quantumfold-storygen-backend.onrender.com",
  // baseURL : "http://localhost:8000",
  timeout: 300000,
  headers: { 'Content-Type': 'application/json'},
});

export default axiosInstance;